const redCarpet = [...Array(104)].map((_, index) => ({
  imgPath: `https://budgitawards.s3.eu-west-2.amazonaws.com/2022_red_carpet/img_${
    index + 1
  }.jpg`,
}));

export default redCarpet;
